import React, { Component } from "react"
import PropTypes from "prop-types";
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Row,
  UncontrolledTooltip,
} from "reactstrap"

import { AvField, AvForm, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import TLVRenderer from "components/Decoders/TLVRenderer";
import ErrorMessage from "components/Common/ErrorMessage";
import "../../pages.scss"

import {
  tlvParseRequest,
  tlvUpdateHexValue,
  tlvClearState,
} from "../../../store/actions"

import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

class TLVParser extends Component {
  constructor(props) {
    super(props)
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.dataChange = this.dataChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.formRef = React.createRef();
  }

  handleValidSubmit = (e, values) => {
    this.props.tlvParseRequest(values.data, values.searchOption)
  }

  dataChange = (event) => {
    const hexValue = event.target.value.toUpperCase()
    this.props.tlvUpdateHexValue(hexValue)
  }

  handleClear = () => {
    this.props.tlvClearState()
    if (this.formRef.current) {
      this.formRef.current.reset()
    }
  }

  handleKeyPress = (e) => {
    const char = e.key
    const isValidHex = /^[0-9A-Fa-f]$/.test(char)
    const isControlKey = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(char)
    
    if (!isValidHex && !isControlKey && char.length === 1) {
      e.preventDefault()
    }
  }

  render() {
    const defaultValues = { searchOption: true }
    const { tlv } = this.props
    
    return (
      <React.Fragment>
        <div className="general-wrapper" style={{ 
          paddingTop: '5.5rem',
          paddingLeft: '2rem', 
          paddingBottom: '1rem' , 
          paddingRight: '2rem', 
          backgroundColor:'#ffffff' ,
          border: 'none',
          boxShadow: 'none',
          height: 'calc(100vh - 80px)',
          overflow: 'hidden'
        }}>
          <Helmet>
            <MetaTags>
              <title>Wechip - Wechip Payment Tools | {this.props.t("tlvDataParser")}</title>
              <meta name="description" content="TLV Parser is a tool or software component used to parse and interpret TLV (Tag-Length-Value) encoded data structures commonly used in various protocols and standards such as EMV (Europay, Mastercard, Visa). Explore the principles and techniques behind TLV parsing, its applications in decoding structured data, and its significance in protocol analysis and development." />
              <meta name="keywords" content="TLV Parser, Tag-Length-Value, TLV decoding, TLV data structures, EMV, protocol analysis, structured data decoding, data parsing" />
            </MetaTags>
          </Helmet>
          
          <Container fluid style={{ height: 'calc(100vh - 170px)', display: 'flex', flexDirection: 'column' }}>
            <Row style={{maxWidth: 'fit-content'}}>
              <Col xs="12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18">{this.props.t("tlvDataParser")}</h4>
                </div>
              </Col>
            </Row>
            <div className="text-muted" style={{maxWidth: 'fit-content', marginBottom: '10px'}}>
              {this.props.t("tlvDataInfo")}
            </div>
            <Row style={{ flex: '0 0 auto' }}>
              <Col xs={12}>
                <Card style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
                  <CardBody style={{ padding: '0' }}>
                    <AvForm 
                      onValidSubmit={this.handleValidSubmit} 
                      model={defaultValues}
                      ref={this.formRef}
                    >
                      <Row className="rowAes">
                        <Col lg={6} md={8} sm={12}>
                          <FormGroup>
                            <div style={{ marginBottom: '15px' }}>
                              <AvRadioGroup inline name="searchOption">
                                <AvRadio value={true} label="BER-TLV" />
                                <AvRadio value={false} label="Custom TLV" />
                              </AvRadioGroup>
                            </div>
                            <div className="position-relative">
                              <div className="position-absolute" style={{ top: '-25px', right: '5px', zIndex: 10 }}>
                                <div className="d-flex align-items-center gap-2">
                                  {tlv.showLengthBadge && (
                                    <span className="badgecount badge bg-success" style={{ fontSize: '0.75rem' }}>
                                      {tlv.dataLength} Length
                                    </span>
                                  )}
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target="Data"
                                  >
                                    {this.props.t("tlvDataInfo")}
                                  </UncontrolledTooltip>
                                  <i
                                    className="dripicons-information"
                                    id="Data"
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                </div>
                              </div>
                              <AvField
                                name="data"
                                placeholder="At Least One TLV Data (e.g. 5F2A020978)"
                                type="textarea"
                                value={tlv.currentHexValue}
                                className="form-control"
                                onChange={this.dataChange}
                                onKeyPress={this.handleKeyPress}
                                style={{ 
                                  height: '120px',
                                  resize: 'none',
                                  fontSize: '0.875rem'
                                }}
                                validate={{ 
                                  required: { value: true },
                                  pattern: { value: /^[0-9A-Fa-f]+$/ }
                                }}
                              />
                            </div>
                            <div className="d-flex justify-content-end gap-2" style={{paddingTop: 5}}>
                              <Button
                                onClick={this.handleClear}
                                color="secondary"
                              >
                                {this.props.t("clearButton")}
                              </Button>
                              <Button
                                type="submit"
                                disabled={tlv.buttonTimer || tlv.isLoading}
                                color="primary"
                              >
                                {tlv.isLoading ? this.props.t("parsing") : this.props.t("parseButton")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row style={{ flex: '1 1 auto', minHeight: 0 }}>
              <Col xs={12} style={{ height: '100%' }}>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <ErrorMessage 
                    error={tlv.error}
                    title={this.props.t("tlvParseOperationFail")}
                    style={{ flex: '0 0 auto' }}
                  />
                  
                  {tlv.apiResponse && tlv.apiResponse.resultData && tlv.apiResponse.resultData.nodes && (
                    <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                      <TLVRenderer 
                        nodes={tlv.apiResponse.resultData.nodes}
                        inputHex={tlv.apiResponse.resultData.inputHex}
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

TLVParser.propTypes = {
  t: PropTypes.any,
  tlv: PropTypes.object.isRequired,
  tlvParseRequest: PropTypes.func.isRequired,
  tlvUpdateHexValue: PropTypes.func.isRequired,
  tlvClearState: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  tlv: state.decoder.tlv
})

const mapDispatchToProps = {
  tlvParseRequest,
  tlvUpdateHexValue,
  tlvClearState,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TLVParser));
